// extracted by mini-css-extract-plugin
export default {"link":"slogan_link__olgqj","pagination":"slogan_pagination__8oZoK","container":"slogan_container__xmXfh"};